import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { CurrentSubscription, SubscriptionPlan } from 'src/app/core/models/subscription.model';

@Component({
  selector:    'app-subscription-status',
  templateUrl: './subscription-status.component.html',
  styleUrls:   ['./subscription-status.component.css']
})
export class SubscriptionStatusComponent implements OnInit {

  subscription?: CurrentSubscription;

  constructor(
    private subscriptionService: SubscriptionService,
    private router:              Router
  ) {}

  ngOnInit(): void {
    this.subscriptionService.loadCurrent().subscribe({
      next: (sub) => { this.subscription = sub; }
    });
  }

  get showUpgradePrompt(): boolean {
    // Show free plan prompt only when NOT in trial
    return this.subscription?.plan === 'Free' &&
           !this.subscription?.isTrial;
  }

  get showExpiryWarning(): boolean {
    return !!this.subscription &&
           !this.subscription.isTrial &&
           this.subscription.plan !== 'Free' &&
           this.subscription.daysRemaining <= 7;
  }

get planBadgeClass(): string {
  switch (this.subscription?.plan) {
    case SubscriptionPlan.Starter:
      return 'ss__badge--starter';

    case SubscriptionPlan.Professional:
      return 'ss__badge--pro';

    case SubscriptionPlan.Enterprise:
      return 'ss__badge--enterprise';

    case SubscriptionPlan.Free:
    default:
      return 'ss__badge--free';
  }
}

  goToPricing(): void {
    this.router.navigate(['/pricing']);
  }
}